import { LockRemoveIcon } from './LockRemoveIcon';

/**
 * author: Colton Wiscombe
 * id 201B2126-8481-413A-884F-BE6C8C62D531
 * name lock-remove
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-remove.svg
 * tags
 * - Lock 
 */
export const EncryptionRemoveIcon = LockRemoveIcon;
export default EncryptionRemoveIcon